import { memo, useCallback } from "react";
import { StoryBibleGeneratedEntityCardChrome } from "@sudowrite/shared-chat";
import type { StoryBibleGeneratedEntity } from "~shared/agenticChat/storyBibleGeneratedEntity";
import { navigateToEntityMention, navigateToStoryBibleFromChatLink } from "./mentions/navigateToEntityMention";
import { storyBibleGeneratedEntityMentionId } from "~shared/agenticChat/storyBibleGeneratedEntity";
import { getStoryBibleSectionIconForGeneratedEntity } from "./storyBibleCta";
import { storyBibleCardWebIcons, storyBibleSectionWebIcon } from "./planCardWebIcons";

type Props = {
  entity: StoryBibleGeneratedEntity;
  activeDocumentId?: string | null;
  activeProjectId?: string | null;
};

export const StoryBibleGeneratedEntityCard = memo(({
  entity,
  activeDocumentId,
  activeProjectId,
}: Props) => {
  const handleClick = useCallback(() => {
    if (entity.entityType === "story_bible_section") {
      navigateToStoryBibleFromChatLink(`sudowrite://story-bible/${entity.entityId}`);
      return;
    }
    navigateToEntityMention(storyBibleGeneratedEntityMentionId(entity), {
      activeDocumentId,
      activeProjectId,
    });
  }, [entity, activeDocumentId, activeProjectId]);

  const accessibilityLabel =
    entity.entityType === "outline_chapter"
      ? `View ${entity.name} in Outline`
      : entity.entityType === "story_bible_section" && entity.entityId === "characters"
        ? `View ${entity.name} in Characters`
        : `View ${entity.name} in Story Bible`;

  return (
    <StoryBibleGeneratedEntityCardChrome
      entity={entity}
      sectionIcon={storyBibleSectionWebIcon(getStoryBibleSectionIconForGeneratedEntity(entity))}
      frameIcon={storyBibleCardWebIcons.frame}
      chevronRight={storyBibleCardWebIcons.chevronRight}
      onPress={handleClick}
      accessibilityLabel={accessibilityLabel}
    />
  );
});
